import { Vue } from 'vue-property-decorator'
import { ServiceRequestRepository } from './ServiceRequestServiceOrderRepository'
import ServiceRequestModel from '../../ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceRequestServiceOrderController {
  state = ServiceRequestModel.getInstance();

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestServiceOrderController', new ServiceRequestServiceOrderController())
  }

  async loadDatatable () {
    return await ServiceRequestRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await ServiceRequestRepository.loadDatatableModel(params)
  }

  async getPerson (id) {
    const { registros } = await ServiceRequestRepository.getPerson(id)
    return registros[0]
  }

  async getConsumerUnit (id) {
    const { registros } = await ServiceRequestRepository.getConsumerUnit(id)
    return registros[0]
  }

  async gravarServiceOrder (params) {
    return await ServiceRequestRepository.gravarServiceOrder(params)
  }

  async alterarServiceOrder (params) {
    return await ServiceRequestRepository.alterarServiceOrder(params)
  }

  async loadForm () {
    return await ServiceRequestRepository.loadForm()
  }

  async loadFormDetalhar () {
    return await ServiceRequestRepository.loadFormDetalhar()
  }

  async loadFormPesquisar () {
    return await ServiceRequestRepository.loadFormPesquisar()
  }

  async pesquisarServiceOrderDataTable (consumerUnit, serviceRequest) {
    return await ServiceRequestRepository.pesquisarServiceOrderDataTable(consumerUnit, serviceRequest)
  }

  async pesquisarServiceOrder (params) {
    return await ServiceRequestRepository.pesquisarServiceOrder(params)
  }

  async pesquisarServiceOrderById (id) {
    return await ServiceRequestRepository.pesquisarServiceOrderById(id)
  }

  async pesquisarServiceOrderByIdDetalhar (id) {
    return await ServiceRequestRepository.pesquisarServiceOrderByIdDetalhar(id)
  }

  async downloadFile (filePath, nmIdentificacaoParserFile) {
    return await ServiceRequestRepository.downloadFile(filePath, nmIdentificacaoParserFile)
  }

  async loadFormAlterar (params) {
    return await ServiceRequestRepository.loadFormAlterar(params)
  }

  async pesquisarFiles (params) {
    return await ServiceRequestRepository.pesquisarFiles(params)
  }

  async loadFormGravar () {
    return await ServiceRequestRepository.loadFormGravar()
  }

  async createUnitCategory (params) {
    return await ServiceRequestRepository.createUnitCategory(params)
  }

  async deleteCategory (id) {
    await ServiceRequestRepository.deleteCategory(id)
  }
}
